import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import '../Style/Navbar.css';
import jwt_decode from "jwt-decode";
import { AuthContext } from "../context/AuthContext";
import { BsPerson } from 'react-icons/bs';

const AppNavbar = () => {
    const [usuario, setUsuario] = useState('');
    const [rol, setRol] = useState('');
    const { setToken } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
        } else {
            try {
                const decoded = jwt_decode(token);
                setUsuario(decoded.username || 'Usuario');
                setRol(decoded.rol);
            } catch (error) {
                console.error('Error al decodificar el token', error);
                navigate('/login');
            }
        }
    }, [navigate]);

    const handleLogout = () => {
        setToken(null);
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <Navbar expand="lg" className="navbar-custom">
            <Container>
                <Navbar.Brand as={Link} to="/home" className="navbar-brand-left">
                    <img
                        src="/Escudo_Municipalidad.png"
                        alt="Logo"
                        width="85"
                        height="70"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/home">Campañas</Nav.Link>
                        {rol === 'admin' && <Nav.Link as={Link} to="/campaigns">Campañas</Nav.Link>}
                    </Nav>
                    <Nav>
                        {usuario ? (
                            <>
                                <NavDropdown
                                    title={<BsPerson size={30} className="text-white" />}
                                    id="basic-nav-dropdown"
                                    align="start"
                                >
                                    <NavDropdown.ItemText>
                                        Bienvenido, {usuario}
                                    </NavDropdown.ItemText>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item onClick={handleLogout}>
                                        Cerrar Sesión
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </>
                        ) : (
                            <Nav.Link as={Link} to="/">Iniciar Sesión</Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default AppNavbar;
